module.exports = __webpack_public_path__ + "static/media/call-light.8a5b0194.svg";